import axios from "axios";
const backend_url = process.env.VUE_APP_HOSTNAME
const domain_url = process.env.VUE_APP_DOMAIN
const ENV = process.env.NODE_ENV
const MODE = process.env.VUE_APP_MODE
const SUPPORT_BOT = (process.env.VUE_APP_AUTH_BOT) ? process.env.VUE_APP_AUTH_BOT : ''
const VERSION = (process.env.VUE_APP_VERSION) ? process.env.VUE_APP_VERSION : '1'
export default class Connect {
    constructor() {

    }

    get env() {
        return ENV
    }
    
    get mode() {
        return MODE
    }

    get version() {
        return VERSION
    }

    get backend_url() {
        return backend_url
    }

    get domain_url() {
        return domain_url
    }

    get support_bot() {
        return SUPPORT_BOT
    }

    //PUBLIC
    // список доступных курсов валют по типу
    async GetRatesByType(type) {
        const response = await axios.get(`/api/public/get_rates/${type}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{ 
            console.log('error GetRatesByType()');
            return Promise.resolve({result: false})
        }
    }

    // список нулевых курсов валют
    async GetNulledRates() {
        const response = await axios.get(`/api/public/get_nulled_rates/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{ 
            console.log('error GetNulledRates()');
            return Promise.resolve({result: false})
        }
    }

    async GetRatesForConverter() {
        const response = await axios.get(`/api/public/get_rates_for_converter/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetRatesForConverter()');
            return Promise.resolve({result: false})
        }
    }

    async get_countries() {
        const response = await axios.get(`/api/public/get_countries/array`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data) 
        }else{
            console.log('error get_countries()');
            return Promise.resolve({result: false})
        }
    }

    // TODO: лишний, убрать. Оставить тот что в payment.js
    async currency_list(type='array') {
        const response = await axios.get(`/api/public/get_currencies/${type}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error currency_list()');
            return Promise.resolve({result: false})
        }
    }

    async bank_list(type) {
        const response = await axios.get(`/api/public/get_banks/${type}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error bank_list()');
            return Promise.resolve({result: false})
        }
    }

    // получение всех отзывов
    async get_reviews(data) {
        const response = await axios.post(`/api/public/get_reviews/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    // получение статистики по отзывам
    async get_reviews_stat() {
        const response = await axios.get(`/api/public/review_stat/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    // PUBLIC-LOGIN
    async forgot_pass(email) {
        const response = await axios.get(`/api/public/forgot/${email}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error forgot_pass()')
            return Promise.resolve({result: false})
        }
    }

    async get_hash(hash) {
        const response = await axios.get(`/api/public/get_hash/${hash}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_hash()')
            return Promise.resolve({result: false})
        }
    }

    async change_pass(hash, pass1, pass2) {
        const response = await axios.post(`/api/public/change_pass/`, { hash: hash, pass1: pass1, pass2: pass2 }).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error change_pass()')
            return Promise.resolve({result: false})
        }
    }

    // PUBLIC-FILES
    // отправка файлов
    async sendFiles(formData, url = '/api/public/files/upload/') {
        const response = await axios.post(url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    // PUBLIC-OTHER
    // счет по hash
    async get_bill(hash) {
        const response = await axios.get(`/api/public/get_bill/${hash}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error get_bill()')
            return Promise.resolve({result: false})
        }
    }

    // статус страницы
    async GetStatus() {
        const response = await axios.get(`/api/public/status/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error GetStatusPage()')
            return Promise.resolve({result: false})
        }
    }

    // USER
    // данные пользователя
    async user_current () {
        const response = await axios.get(`/api/user/get_user/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        } else{
            console.log('error user_current()');
            return Promise.resolve({result: false})
        }
    }

    // обновление пользователя
    async user_update (data) {
        const response = await axios.post(`/api/user/upd/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error user_update()')
            return Promise.resolve({result: false})
        }
    }

    // получатели пользователя
    async user_recipients(type='array') {
        const response = await axios.get(`/api/user/recipients/${type}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error user_recipients()')
            return Promise.resolve({result: false})
        }
    }

    // список получателей пользователя
    async GetPersonalRecipients(limit=10, skip=0) {
        const response = await axios.get(`/api/user/recipient/list/?limit=${limit}&skip=${skip}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetPersonalRecipients()')
            return Promise.resolve({result: false})
        }
    }

    // список отправителей пользователя
    async GetPersonalSenders(limit=10, skip=0) {
        const response = await axios.get(`/api/user/sender/list/?limit=${limit}&skip=${skip}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetPersonalSenders()')
            return Promise.resolve({result: false})
        }
    }

    // информация об отправителе по id
    async GetPersonalSenderById(id) {
        const response = await axios.get(`/api/user/sender/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetPersonalSenderById()')
            return Promise.resolve({result: false})
        }
    }

    // добавление отправителя
    async AddPersonalSender(data) {
        const response = await axios.post(`/api/user/sender/add/`, {data}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error AddPersonalSender()')
            return Promise.resolve({result: false})
        }
    }

    // файлы пользователя
    async GetPersonalFilesByIds(files) {
        const response = await axios.post(`/api/user/file/list_by_ids/`, {files}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error GetPersonalFilesByIds()')
            return Promise.resolve({result: false})
        }
    }

    // отправка сообщений авторизированным пользователем
    async sendMessage(message, from, files_arr_id) {
        const response = await axios.post(`/api/user/message/send/`, {message: message, from: from, files_arr_id: files_arr_id}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    // отправка сообщений НЕ авторизированным пользователем
    async sendPublicMessage(message, from) {
        const response = await axios.post(`/api/public/message/send/`, {message: message, from: from}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }
    
    // статистика переводов пользователя
    async user_get_stat () {
        const response = await axios.get(`/api/user/get_stat/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error user_get_stat()')
            return Promise.resolve({result: false})
        }
    }

    // получение файла по path
    async UserGetFile(path){
        const response = await axios({
            method: 'GET',
            url: `/api/user/file/get_file/?path=${path}`,
            responseType: 'blob'
        })
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error get_file()')
            return Promise.resolve({result: false})
        }
    }

    // USER-TRANSFER
    // получение переводов рефералов партнера
    async get_ref_transfers(limit=10, skip=0, sort={}) {
        const response = await axios.post(`/api/user/transfer/get_referals/`, {limit: limit, skip: skip, sort: sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_referals()');
            return Promise.resolve({result: false})
        }
    }

    async get_ref_avatars(){
        const response = await axios.get(`/api/user/partner/get_avatars/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    // отправка qr кода по трансферу
    async send_qr(code, transfer_id) {
        const response = await axios.post(`/api/user/transfer/qr/`, {code: code, id: transfer_id}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error send_qr()');
            return Promise.resolve({result: false})
        }
    }

    // отправка отзыва 
    async send_review(data) {
        const response = await axios.post(`/api/user/review/add/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    // список задач
    async GetTaskList() {
        const response = await axios.get(`/api/user/task/list/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            return Promise.resolve({result: false})
        }
    }

    // выполнение задания
    async CheckTaskByCode(code) {
        const response = await axios.get(`/api/user/task/check/${code}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            return Promise.resolve({result: false})
        }
    }

    // USER-PARTNER
    // стать партнером | user
    async be_partner () {
        const response = await axios.get(`/api/user/partner/be/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error be_partner()')
            return Promise.resolve({result: false})
        }
    }

    // получение рефералов партнера
    async get_referals(limit=10, skip=0, sort={}) {
        const response = await axios.post(`/api/user/partner/get_referals/`, {limit: limit, skip: skip, sort: sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_referals()');
            return Promise.resolve({result: false})
        }
    }

    // текущий партнер
    async get_partner() {
        const response = await axios.get(`/api/user/partner/get/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_partner()')
            return Promise.resolve({result: false})
        }
    }

    // получение транзакций партнера
    async get_ref_trans(limit=10, skip=0) {
        const response = await axios.post(`/api/user/partner/trans_list/`, {limit: limit, skip: skip}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_referals()');
            return Promise.resolve({result: false})
        }
    }
    
    // USER-TRANSFER
    // переводы пользователя
    async user_transfers(limit, skip) {
        const response = await axios.post(`/api/user/transfer/list/`, {limit: limit, skip: skip}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error user_transfers()')
            return Promise.resolve({result: false})
        }
    }

    // создание трансфера
    async transfer_create(data) {
        const response = await axios.post(`/api/user/transfer/create/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error transfer_create()')
            return Promise.resolve({result: false})
        }
    }

    async transfer_getby_id(id) {
        const response = await axios.get(`/api/user/transfer/get/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error transfer_getby_id()')
            return Promise.resolve({result: false})
        }
    }

    // получить реквизиты карты по id трансфера
    async transfer_get_card(id) {
        const response = await axios.get(`/api/user/transfer/get_card/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error transfer_getby_id()')
            return Promise.resolve({result: false})
        }
    }

    // подтверждение оплаты трансфера
    async transfer_confirm_payment(id) {
        const response = await axios.get(`/api/user/transfer/confirm/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error transfer_getby_id()')
            return Promise.resolve({result: false})
        }
    }

    // подтверждение получения трансфера
    async transfer_got_payment(id) {
        const response = await axios.get(`/api/user/transfer/got/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error transfer_getby_id()')
            return Promise.resolve({result: false})
        }
    }

    // закрытие трансфера
    async transfer_close(id) {
        const response = await axios.get(`/api/user/transfer/close/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error transfer_close()')
            return Promise.resolve({result: false})
        }
    }

    // получение чека по id трансфера
    async transfer_get_receipt(id) {
        const response = await axios.get(`/api/user/transfer/get_receipt/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    // Пополнение счета переводом
    async TopupWalletByTransfer(data) {
        const response = await axios.post(`/api/user/transfer/topup/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error TopupWalletByTransfer()')
            return Promise.resolve({result: false})
        }
    }

    // Вывод со счета переводом
    async WithdrawWalletByTransfer(data) {
        const response = await axios.post(`/api/user/transfer/withdraw/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error WithdrawWalletByTransfer()')
            return Promise.resolve({result: false})
        }
    }

    // USER-BILL
    async GetBillProgram (id) {
        const response = await axios.get(`/api/user/bill/be/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetBillProgram()')
            return Promise.resolve({result: false})
        }
    }

    // Создание счета
    async bill_create(data) {
        const response = await axios.post(`/api/user/bill/create/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }
        else {
            console.log('error bill_create()')
            return Promise.resolve({result: false})
        }
    }
    
    // Оплата счета
    async bill_to_pay(data) {
        const response = await axios.post(`/api/user/bill/pay/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error payment_create()')
            return Promise.resolve({result: false})
        }
    }

    // Счета пользователя
    async personal_bills (limit, skip, filter={}, sort={}) {
        const response = await axios.post(`/api/user/bill/list/`, {limit: limit, skip: skip, filter: filter, sort: sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error personal_bills()')
            return Promise.resolve({result: false})
        }
    }

    // переводы по счету
    async get_transfers_by_bill (id) {
        const response = await axios.get(`/api/user/transfer/by_bill/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_transfers_by_bill()')
            return Promise.resolve({result: false})
        }
    }

    // Счет по ID
    async get_bill_by_user (id) {
        const response = await axios.get(`/api/user/bill/get_by_id/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_deal_by_user()')
            return Promise.resolve({result: false})
        }
    }

    // кошелeк пользователя по id
    async GetUserWalletById(id) {
        const response = await axios.get(`/api/user/wallet/get_by_id/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetUserWalletById()')
            return Promise.resolve({result: false})
        }
    }

    // кошелeк пользователя по типу
    async GetUserWalletByType(type) {
        const response = await axios.get(`/api/user/wallet/get_by_type/${type}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetUserWalletByType()')
            return Promise.resolve({result: false})
        }
    }

    // кошельки пользователя
    async GetUserWallets() {
        const response = await axios.get(`/api/user/wallet/all/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetUserWalletById()')
            return Promise.resolve({result: false})
        }
    }

    // транзакции пользователя
    async GetUserTrans(skip) {
        const response = await axios.post(`/api/user/wallet/alltrans/`, {skip: skip}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetUserTrans()')
            return Promise.resolve({result: false})
        }
    }

    // транзакции по кошельку
    async GetUserTransByWalletType(type, skip) {
        const response = await axios.post(`/api/user/wallet/trans/`, {type: type, skip: skip}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetUserTransByWalletType()')
            return Promise.resolve({result: false})
        }
    }

    // перевод между кошельками
    async ExchangeWallet(data) {
        const response = await axios.post(`/api/user/wallet/exchange/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            return Promise.resolve({result: false})
        }
    }

    // Вывод в крипту
    async WithdrawWalletToCrypto(data){
        const response = await axios.post(`/api/user/wallet/withdraw/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            return Promise.resolve({result: false})
        }
    }

    // USER CARDS
    async GetVCardProgram(data) {
        const response = await axios.get(`/api/user/cards/open/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            return Promise.resolve({result: false})
        }
    }

    // Список карт пользователя
    async GetUserCards(type) {
        const response = await axios.get(`/api/user/cards/data/?type=${type}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    // Создание карты
    async CreateCard(data) {
        const response = await axios.post(`/api/user/cards/create/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            return Promise.resolve({result: false})
        }
    }

    // получение карты по id
    async GetUserCardById(id, sensitive=false) {
        const response = await axios.get(`/api/user/cards/get_by_id/${id}?sensitive=${sensitive}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {  
            return Promise.resolve({result: false})
        }
    }

    // получение транзакций карты по id
    async GetUserCardTransactionsById(id, limit=10, skip=0) {
        const response = await axios.post(`/api/user/cards/transactions/`, {id, limit, skip}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {  
            return Promise.resolve({result: false})
        }
    }

    // Пополнение карты
    async TopUpCard(data){
        const response = await axios.post(`/api/user/cards/topup/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            return Promise.resolve({result: false})
        }
    }

    // ADMIN USER
    //список всех пользователей
    async user_list(limit=50, skip=0, filter={}, sort={}, codes=[]) {
        const response = await axios.post(`/api/admin/user/list/`, {limit: limit, skip: skip, filter: filter, sort: sort, codes: codes}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error user_list()');
            return Promise.resolve({result: false})
        }
    }

    // статистика переводов пользователей
    async users_score(limit=50, skip=0, filter={}, sort={}, date1, date2) {
        const response = await axios.post(`/api/admin/user/score/`, {limit: limit, skip: skip, filter: filter, sort: sort, date1, date2}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error users_score()');
            return Promise.resolve({result: false})
        }
    }

    // список всех пользователей по id
    async get_users_list_byids(array, fields) {
        const response = await axios.post(`/api/admin/user/list_by_id/`, {array: array, fields: fields}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_users_list_byids()')
            return Promise.resolve({result: false})
        }
    }

    // получение пользователя по id | admin
    async AdminGetUserById (id, fields) {
        const response = await axios.post(`/api/admin/user/get_by_id/`, {id: id, fields: fields}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error AdminGetUserById()')
            return Promise.resolve({result: false})
        }
    }

    // получение пользователя по id | admin
    async AdminGetUserByLedgerId (id, fields) {
        const response = await axios.post(`/api/admin/user/get_by_ledger_id/`, {ledger_id: id, fields: fields}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error AdminGetUserByLedgerId()')
            return Promise.resolve({result: false})
        }
    }

    // список всех получателей по id пользователей
    async get_recipients_list_byids(array, fields) {
        const response = await axios.post(`/api/admin/recipient/list_by_id/`, {array: array, fields: fields}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_users_list_byids()')
            return Promise.resolve({result: false})
        }
    }

    // Обновление пользователя | admin
    async UpdateUserByAdmin(id, data) {
        const response = await axios.post(`/api/admin/user/edit/`, {id: id, data: data}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error UpdateUserByAdmin()')
            return Promise.resolve({result: false})
        }
    }

    // получение получателей по id пользователя | admin
    async GetrecipientsByUserId(id) {
        const response = await axios.get(`/api/admin/recipient/get_by_user_id/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetrecipientsByUserId()')
            return Promise.resolve({result: false})
        }
    }

    // список всех отправителей для админа
    async AdminSendersList(limit=50, skip=0, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/sender/list/`, {limit, skip, filter, sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error AdminSendersList()');
            return Promise.resolve({result: false})
        }
    }

    // обновление статуса отправителя для админа
    async AdminSenderUpdateStatus(id, data) {
        const response = await axios.post(`/api/admin/sender/edit/`, { id, data }).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error AdminSenderUpdateStatus()');
            return Promise.resolve({result: false})
        }
    }

    // проверка KYC отправителя для админа  
    async AdminSendersCheckKyc(id) {
        const response = await axios.get(`/api/admin/sender/check_kyc/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error AdminSendersList()');
            return Promise.resolve({result: false})
        }
    }

    // список всех получателей для админа
    async AdminRecipientsList(limit=50, skip=0, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/recipient/list/`, {limit, skip, filter, sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error AdminRecipientsList()');
            return Promise.resolve({result: false})
        }
    }

    // список блэклиста получателей для админа
    async AdminRecipientsBlacklistList(limit=50, skip=0, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/recipient/blacklist/list/`, {limit, skip, filter, sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error AdminRecipientsBlacklistList()');
            return Promise.resolve({result: false})
        }
    }

    // добавление записи в блэклист получателей для админа
    async AdminRecipientBlacklistAdd(data) {
        const response = await axios.post(`/api/admin/recipient/blacklist/add`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error AdminRecipientBlacklistAdd()');
            return Promise.resolve({result: false})
        }
    }

    // редактирование записи блэклиста получателей для админа
    async AdminRecipientBlacklistEdit(id, data) {
        const response = await axios.post(`/api/admin/recipient/blacklist/edit/`, { id, data }).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error AdminRecipientBlacklistEdit()');
            return Promise.resolve({result: false})
        }
    }

    // обновление полей получателя (в т.ч. статуса) для админа
    async AdminRecipientUpdateStatus(id, data) {
        const response = await axios.post(`/api/admin/recipient/edit/`, { id, data }).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error AdminRecipientUpdateStatus()');
            return Promise.resolve({result: false})
        }
    }

    // ADMIN-TRANSFER
    // получение трансфера админом
    async transfer_getby_admin(id) {
        const response = await axios.get(`/api/admin/transfer/get_by_id/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error transfer_getby_id()')
            return Promise.resolve({result: false})
        }
    }

    // список всех трансферов
    async transfers_list(limit, skip, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/transfer/list/`, {limit: limit, skip: skip, filter: filter, sort: sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error transfers_list()')
            return Promise.resolve({result: false})
        }
    }

    // удаление трансфера админом
    async transfer_del_by_admin(id) {
        const response = await axios.get(`/api/admin/transfer/delete/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error transfer_del_by_admin()')
            return Promise.resolve({result: false})
        }
    }

    // обновление трансфера админом
    async transfer_upd_by_admin(data) {
        const response = await axios.post('/api/admin/transfer/upd/', data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error transfer_upd_by_admin()')
            return Promise.resolve({result: false})
        }
    }

    // статистика по переводам
    async get_admin_data(code) {
        const response = await axios.get(`/api/admin/transfer/get_data/${code}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_admin_data()')
            return Promise.resolve({result: false})
        }
    }

    // ADMIN-MERCHANT
    // получение мерчанта админом
    async get_merchant_by_id(id, period) {
        const response = await axios.post(`/api/admin/merchant/get_by_id/`, {id: id, period: period}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_merchant_by_id()')
            return Promise.resolve({result: false})
        }
    }

    // список всех мерчантов для админа    
    async merchant_list(limit=50, skip=0, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/merchant/list/`, {limit: limit, skip: skip, filter: filter, sort: sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error merchant_list()');
            return Promise.resolve({result: false})
        }
    }

    // обновление мерчанта | admin
    async UpdateMerchantByAdmin(data) {
        const response = await axios.post('/api/admin/merchant/upd/', data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error UpdateMerchantByAdmin()')
            return Promise.resolve({result: false})
        }
    }

    // список всех мерчантов по id
    async get_merchants_list_byids(array, fields) {
        const response = await axios.post(`/api/admin/merchant/list_by_id/`, {array: array, fields: fields}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_merchants_list_byids()')
            return Promise.resolve({result: false})
        }
    }

    // подтверждение оплаты трансфера админом за ПОЛУЧАТЕЛЯ
    async ConfirmTransferForRecipientByAdmin(transfer_id) {
        const response = await axios.get(`/api/admin/transfer/confirm_recipient/${transfer_id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error ConfirmTransferForRecipientByAdmin()')
            return Promise.resolve({result: false})
        }
    }

    // подтверждение оплаты трансфера админом за ОТПРАВИТЕЛЯ
    async ConfirmTransferForSenderByAdmin(transfer_id) {
        const response = await axios.get(`/api/admin/transfer/confirm_sender/${transfer_id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error ConfirmTransferForSenderByAdmin()')
            return Promise.resolve({result: false})
        }
    }

    // подтверждение оплаты трансфера админом за МЕРЧАНТОВ
    async ConfirmTransferForMerchantsByAdmin(transfer_id, direction = 'both') {
        const response = await axios.post(`/api/admin/transfer/confirm_merchants/`, { transfer_id, direction }).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error ConfirmTransferForMerchantsByAdmin()')
            return Promise.resolve({result: false})
        }
    }

    async ConfirmTransferFromModerationByAdmin(transfer_id) {
        const response = await axios.get(`/api/admin/transfer/moderation/resolve/${transfer_id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error ConfirmTransferFromModerationByAdmin()')
            return Promise.resolve({result: false})
        }
    }
    
    // Пополнение баланса мерчанта админом
    async AddBalanceToMerchantByAdmin(data) {
        const response = await axios.post(`/api/admin/merchant/add_balance/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    // Списание баланса мерчанта админом
    async WithdrawBalanceFromMerchantByAdmin(data) {
        const response = await axios.post(`/api/admin/merchant/withdraw_balance/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    // Закрыть трансфер админом
    async CloseTransferByAdmin(transfer_id) {
        const response = await axios.get(`/api/admin/transfer/close/${transfer_id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    // Проверка статуса платежа по трансферу админом
    async CheckPaymentStatusByAdmin(transfer_id) {
        const response = await axios.get(`/api/admin/transfer/check_payment/${transfer_id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    // ADMIN-PARTNER
    // получить партнера по id | admin
    async get_partner_by_id(id) {
        const response = await axios.get(`/api/admin/partner/get_by_id/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_partner_by_id()')
            return Promise.resolve({result: false})
        }
    }

    //список всех партнеров
    async partner_list(limit=50, skip=0, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/partner/list/`, {limit: limit, skip: skip, filter: filter, sort: sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error partner_list()');
            return Promise.resolve({result: false})
        }
    }

    // Создать ref ссылку по коду
    async CreateRefLinkByCode(code) {
        const response = await axios.get(`/api/admin/partner/create_by_code/${code}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error CreateRefLinkByCode()')
            return Promise.resolve({result: false})
        }
    }

    // ADMIN-CARD
    // получение карты мерчанта админом
    async get_card_by_id(id) {
        const response = await axios.get(`/api/admin/card/get_by_id/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_card_by_id()')
            return Promise.resolve({result: false})
        }
    }

    // обновление карты мерчанта админом 
    async update_card_by_admin(data) {
        const response = await axios.post(`/api/admin/card/upd/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error update_card_by_admin()')
            return Promise.resolve({result: false})
        }
    }

    // добавление карты мерчанта
    async add_card(data) {
        const response = await axios.post(`/api/admin/card/add/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error add_card()')
            return Promise.resolve({result: false})
        }
    }

    // ADMIN-WALLET
    // создает кошелек для пользователя
    async create_wallet (data) {
        const response = await axios.post(`/api/admin/wallet/create/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error create_wallet()')
            return Promise.resolve({result: false})
        }
    }

    // создает кошелек для мерчанта
    async create_wallet_mr (data) {
        const response = await axios.post(`/api/admin/wallet/create_mr/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error create_wallet_mr()')
            return Promise.resolve({result: false})
        }
    }

    // создает кошелек для мерчанта
    async AdminCreateDepositWallet (data) {
        const response = await axios.post(`/api/admin/wallet/create_deposit/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error AdminCreateDepositWallet()')
            return Promise.resolve({result: false})
        }
    }

    // кошелeк пользователя
    async get_wallet_by_id(id) {
        const response = await axios.get(`/api/admin/wallet/get_by_id/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_wallet_by_id()')
            return Promise.resolve({result: false})
        }
    }

    // кошельки пользователей
    async wallets_list (limit, skip, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/wallet/list/`, {limit: limit, skip: skip, filter: filter, sort: sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error wallets_list()')
            return Promise.resolve({result: false})
        }
    }

    // пополнение кошелька админом
    async TopupWalletByAdmin(data){
        const response = await axios.post(`/api/admin/wallet/topup/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    // списание с кошелька админом
    async WithdrawWalletByAdmin(data){
        const response = await axios.post(`/api/admin/wallet/withdraw/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    // перевод между кошельками админом
    async TransferWalletByAdmin(data){
        const response = await axios.post(`/api/admin/wallet/transfer/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    // ADMIN-ACCOUNT
    // аккаунты кошельков
    async accounts_list (limit, skip, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/wallet/accounts/`, {limit: limit, skip: skip, filter: filter, sort: sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error accounts_list()')
            return Promise.resolve({result: false})
        }
    }

    // аккаунт кошелька
    async get_account_by_id(id, limit, skip, filter, sort) {
        const response = await axios.post(`/api/admin/wallet/get_account/`, {id: id, limit: limit, skip: skip, filter: filter, sort: sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_account_by_id()')
            return Promise.resolve({result: false})
        }
    }

    // ADMIN-TRANSACTION
    // список транзакций админа
    async trans_list (limit, skip, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/trans/list/`, {limit: limit, skip: skip, filter: filter, sort:sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error trans_list()')
            return Promise.resolve({result: false})
        }
    }

    // ADMIN-FILES
    async files_list (limit, skip, filter={}) {
        const response = await axios.post(`/api/admin/file/list/`, {limit: limit, skip: skip, filter: filter}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error files_list()')
            return Promise.resolve({result: false})
        }
    }

    // получение файла по path
    async get_file(path){
        const response = await axios({
            method: 'GET',
            url: `/api/admin/file/get_file/?path=${path}`,
            responseType: 'blob'
        })
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error get_file()')
            return Promise.resolve({result: false})
        }
    }

    // получение файла по ID
    async get_file_by_id(id){
        const response = await axios({
            method: 'GET',
            url: `/api/admin/file/get_file/${id}`,
            responseType: 'blob'
        })
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error get_file_by_id()')
            return Promise.resolve({result: false})
        }
    }
    
    // ADMIN VCARD
    async GetVcardList(limit, skip, filter={}, sort={}) {
        const response = await axios.post(`/api/admin/vcard/list/`, {limit: limit, skip: skip, filter: filter, sort: sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error update_card_by_admin()')
            return Promise.resolve({result: false})
        }
    }

    async GetVcardDetails(id) {
        const response = await axios.get(`/api/admin/vcard/get_by_id/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error GetVcardDetails()')
            return Promise.resolve({result: false})
        }
    }

    async AdminGetVcardTransactions(id, limit=10, skip=0) {
        const response = await axios.post(`/api/admin/vcard/transactions/`, {id, limit, skip}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error AdminGetVcardTransactions()')
            return Promise.resolve({result: false})
        }
    }

    async AdminWithdrawVcard(data) {
        const response = await axios.post(`/api/admin/vcard/withdraw/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error AdminWithdrawVcard()')
            return Promise.resolve({result: false})
        }
    }

    async AdminUpdateVcard(id, data) {
        const response = await axios.post(`/api/admin/vcard/edit/`, { id, data }).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error AdminUpdateVcard()')
            return Promise.resolve({result: false})
        }
    }

    // ADMIN-OTHER
    // список всех доступных курсов валют для админа
    async get_admin_rates() {
        const response = await axios.get('/api/admin/get_rates/').then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{ 
            console.log('error get_admin_rates()');
            return Promise.resolve({result: false})
        }
    }

    // пополнение кошелька админом
    async AdminGetFinancial(){
        const response = await axios.get(`/api/admin/financial/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            return Promise.resolve({result: false})
        }
    }

    // обновление курса
    async rate_upd_by_admin(id, data) {
        const response = await axios.post('/api/admin/rate_upd/', {id: id, data: data}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error rate_upd_by_admin()')
            return Promise.resolve({result: false})
        }
    }

    // добавление курса
    async rate_add_by_admin(data) {
        const response = await axios.post('/api/admin/rate_add/', data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error rate_add_by_admin()')
            return Promise.resolve({result: false})
        }
    }

    // все банки для админа
    async get_admin_banks() {
        const response = await axios.get('/api/admin/get_banks/').then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_admin_banks()');
            return Promise.resolve({result: false})
        }
    }

    // обновление банка
    async bank_upd_by_admin(data) {
        const response = await axios.post('/api/admin/bank_upd/', data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error bank_upd_by_admin()')
            return Promise.resolve({result: false})
        }
    }

    // обновление платежной системы 
    async PaySysUpdateByAdmin(data) {
        const response = await axios.post('/api/admin/pays_upd/', data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error PaySysUpdateByAdmin()')
            return Promise.resolve({result: false})
        }
    }

    // добавление банка
    async bank_add_by_admin(data) {
        const response = await axios.post('/api/admin/bank_add/', data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error bank_add_by_admin()')
            return Promise.resolve({result: false})
        }
    }

    // получение всех операций
    async GetOperations(limit, skip, filter={}, sort={}) {
        const response = await axios.post('/api/admin/operation/list/', {limit: limit, skip: skip, filter: filter, sort: sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error GetOperations()')
            return Promise.resolve({result: false})
        }
    }

    // откат операции по ID
    async RevertOperationById(id, description='') {
        const response = await axios.post(`/api/admin/operation/revert`, {operation_id: id, description}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error RevertOperationById()')
            return Promise.resolve({result: false})
        }
    }

    // решение по risk операции
    async ResolveRiskOperationById(id, description = '', decision = 'approve') {
        const response = await axios.post(`/api/admin/operation/resolve`, {operation_id: id, description, decision}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error ResolveRiskOperationById()')
            return Promise.resolve({result: false})
        }
    }

    async ReviewWithdrawalOperation(id, decision, description) {
        const response = await axios.post('/api/admin/operation/withdrawal/review/', {
            operation_id: id,
            decision,
            description
        }).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error ReviewWithdrawalOperation()')
            return Promise.resolve({result: false})
        }
    }

    // MERCHANT
    // данные мерчанта
    async get_merchant(date) {
        const response = await axios.get(`/api/merchant/get_current/${date}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_merchant()')
            return Promise.resolve({result: false})
        }
    }

    // получение всех доступных курсов валют для мерчанта
    async GetRatesForMerchant() {
        const response = await axios.get(`/api/merchant/get_rates/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error GetRatesForMerchant()')
            return Promise.resolve({result: false})
        }
    }
    
    // получение перевода мерчантом
    async transfer_getby_merchant(id) {
        const response = await axios.get(`/api/merchant/transfer/get_by_id/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error transfer_getby_id()')
            return Promise.resolve({result: false})
        }
    }

    // получение карты мерчантом card_getby_merchant
    async card_getby_merchant(id) {
        const response = await axios.get(`/api/merchant/transfer/get_card/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error card_getby_merchant()')
            return Promise.resolve({result: false})
        }
    }

    // подтверждение оплаты трансфера админом за мерчанта
    async transfer_confirm_by_merchant(id, direction) {
        const response = await axios.post(`/api/merchant/transfer/confirm/`, {id: id, direction: direction}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error transfer_confirm_by_merchant()')
            return Promise.resolve({result: false})
        }
    }

    // Отказ оплаты трансфера мерчантом
    async transfer_reject_by_merchant(id) {
        const response = await axios.get(`/api/merchant/transfer/reject/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error transfer_reject_by_merchant()')
            return Promise.resolve({result: false})
        }
    }

    // переводы мерчанта
    async transfers_mr_list(limit, skip, filters={}) {
        const response = await axios.post(`/api/merchant/transfer/list/`, {limit: limit, skip: skip, filters: filters}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error transfers_list()')
            return Promise.resolve({result: false})
        }
    }

    // запрос на повторное сканирование qr кода от мерчанта отпраки
    async repeat_scat(id) {
        const response = await axios.get(`/api/transfer/repeatscan/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error repeat_scat()');
            return Promise.resolve({result: false})
        }
    }

    // обновление карты мерчанта мерчантом 
    async update_card_by_merchant(data) {
        const response = await axios.post(`/api/merchant/card/upd/`, data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        } else {
            console.log('error update_card_by_merchant()')
            return Promise.resolve({result: false})
        }
    }

    // добавление мерчанта админом
    async AddMerchantByAdmin(data){
        const response = await axios.post('/api/admin/merchant/add/', data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error AddMerchantByAdmin()')
            return Promise.resolve({result: false})
        }
    }

    async GetMerchantProgram(){
        const response = await axios.get(`/api/merchant/be/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error GetMerchantProgram()')
            return Promise.resolve({result: false})
        }
    }

    // файлы мерчанта
    async merchant_files_list (limit, skip, filter={}) {
        const response = await axios.post(`/api/merchant/file/list/`, {limit: limit, skip: skip, filter: filter}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error merchant_files_list()')
            return Promise.resolve({result: false})
        }
    }

    // получение файла по path
    async merchant_get_file(path){
        const response = await axios({
            method: 'GET',
            url: `/api/merchant/file/get_file/?path=${path}`,
            responseType: 'blob'
        })
        if (response && response.status === 200) {
            return Promise.resolve(response.data)
        }else{
            console.log('error get_file()')
            return Promise.resolve({result: false})
        }
    }

    // обновление мерчанта | admin
    async UpdateByMerhcant(data) {
        const response = await axios.post('/api/merchant/upd/', data).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error UpdateByMerhcant()')
            return Promise.resolve({result: false})
        }
    }

    // MERCHAN-WALLET
    // аккаунт кошелька
    async get_account(id, limit, skip) {
        const response = await axios.post(`/api/merchant/wallet/get_user_account/`, {id: id, limit: limit, skip: skip}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_account()')
            return Promise.resolve({result: false})
        }
    }

    // кошелек мерчанта по id | user
    async get_wallet() {
        const response = await axios.get(`/api/merchant/wallet/get/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        }else{
            console.log('error get_account()')
            return Promise.resolve({result: false})
        }
    }

    // USER-PRODUCT (eSIM)
    // список продуктов eSIM
    async GetEsimProducts(limit=20, skip=0, filter={}, sort={}) {
        const response = await axios.post(`/api/user/product/list/`, {limit, skip, filter, sort}).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        } else {
            console.log('error GetEsimProducts()')
            return Promise.resolve({result: false})
        }
    }

    // заказы текущего пользователя
    async GetEsimOrders() {
        const response = await axios.get(`/api/user/product/orders/`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        } else {
            console.log('error GetEsimOrders()')
            return Promise.resolve({result: false})
        }
    }

    // создать заказ (product_id, product_category)
    async CreateEsimOrder(product_id, product_category) {
        const response = await axios.post(`/api/user/product/order/create/`, { product_id, product_category }).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        } else {
            console.log('error CreateEsimOrder()')
            return Promise.resolve({result: false})
        }
    }

    // получить детали заказа по ID
    async GetEsimOrderById(id) {
        const response = await axios.get(`/api/user/product/order/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        } else {
            console.log('error GetEsimOrderById()')
            return Promise.resolve({result: false})
        }
    }

    // покрытие сетей для продукта
    async GetEsimNetworks(id) {
        const response = await axios.get(`/api/user/product/networks/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        } else {
            console.log('error GetEsimNetworks()')
            return Promise.resolve({result: false})
        }
    }

    // информация о провайдере
    async GetEsimProvider(id) {
        const response = await axios.get(`/api/user/product/provider/${id}`).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        } else {
            console.log('error GetEsimProvider()')
            return Promise.resolve({result: false})
        }
    }

    // отменить заказ по ID
    async CancelEsimOrder(id) {
        const response = await axios.post(`/api/user/product/order/cancel/`, { id }).then(res=>res).catch(error => {})
        if (response && response.status === 200) {
            return Promise.resolve(response.data);
        } else {
            console.log('error CancelEsimOrder()')
            return Promise.resolve({result: false})
        }
    }
}

